import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  &.ReceiptRules {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${spacing(5)};
    align-items: start;

    & > * {
      height: fit-content;
    }
  }
`
